export enum ApplicationDetailsMode {
  view = 'view',
  edit = 'edit',
}
